import { useContext, useMemo } from 'react'
import IdentityContext from '../context/IdentityContext'
import { UserDto } from '../config/userConfig'
import useUsers from './useUsers'

export interface Props {
    currentMailbox: string
    currentMailboxFullName: string
    currentUsername: string
    currentEmail?: string
    currentUser?: UserDto
}

export default function useUser(): Props {
    const context = useContext(IdentityContext)
    const { users, getUserByEmail } = useUsers()

    const currentMailbox = useMemo(() => {
        console.debug(`Detected currentMailbox change: ${context.mailbox} || ${context.username}.`)
        return context.mailbox || context.username
    }, [context.mailbox, context.username])
    const currentMailboxFullName = useMemo(() => {
        console.debug(`Detected currentMailboxFullName change: ${getUserByEmail(currentMailbox)?.fullName}.`)
        return getUserByEmail(currentMailbox)?.fullName
    }, [currentMailbox, users])

    return {
        currentMailbox: currentMailbox,
        currentMailboxFullName: currentMailboxFullName,
        currentUsername: context.username,
        currentEmail: context.user?.email,
        currentUser: context.user,
    }
}
